import React from 'react';

/**
 * Basic Information Section for Create/Edit Group Modal
 */
const BasicInfoSection = ({
  formData,
  formErrors,
  touched,
  loading,
  onInputChange,
  onBlur
}) => {
  const inputClass = (field) =>
    `gm-form-input ${formErrors[field] && touched[field] ? 'gm-form-error-input' : ''}`;

  const textareaClass = (field) =>
    `gm-form-textarea ${formErrors[field] && touched[field] ? 'gm-form-error-input' : ''}`;

  return (
    <div>
      <div className="gm-form-grid">
        <div className="gm-form-group">
          <label htmlFor="groupName">
            Group Name <span className="gm-form-required">*</span>
          </label>
          <input
            id="groupName"
            type="text"
            value={formData.name}
            onChange={(e) => onInputChange('name', e.target.value)}
            onBlur={() => onBlur('name')}
            required
            placeholder="e.g., VIP_Traders"
            disabled={loading}
            className={inputClass('name')}
          />
          {formErrors.name && touched.name && (
            <span className="gm-form-error-text">{formErrors.name}</span>
          )}
        </div>

        <div className="gm-form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            value={formData.description}
            onChange={(e) => onInputChange('description', e.target.value)}
            onBlur={() => onBlur('description')}
            placeholder="Describe the purpose and characteristics of this trading group"
            disabled={loading}
            rows={3}
            className={textareaClass('description')}
          />
          {formErrors.description && touched.description && (
            <span className="gm-form-error-text">{formErrors.description}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicInfoSection;
